import React, { useState, useEffect } from "react";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import { Fa0 } from "react-icons/fa6";
import loadConfig from "../../../Services/apiService";
import "./style.css";
import INPUT from "../../../Components/InputComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllAI_CountryOfResidence,
  GetAllAI_NatureOfSupport,
} from "../../../Redux/Reducers/DropDownApplicationInformation";
import {
  GetGeneralInformationData,
  SetGeneralInformation,
} from "../../../Redux/Reducers/GeneralInformation";
import { GetBeneficiaryInformation } from "../../../Redux/Reducers/BeneficiaryInformation";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const GeneralinformationModel = (props) => {
  const AppGuid = useParams();
  const [jsonData, setJsonData] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      GeneralInformation: state.GeneralInformation.GeneralInformation,
      GeneralInformationLoding:
        state.GeneralInformation.loadingGeneralInformation,
      AI_ApplicantType: state.dropDownApplicationInformation.AI_ApplicantType,
      AI_CountryOfResidence:
        state.dropDownApplicationInformation.AI_CountryOfResidence,
      AI_NatureOfSupport:
        state.dropDownApplicationInformation.AI_NatureOfSupport,
      ApplicationInformationValidationPage:
        state.ApplicationInformationValidationPage
          .ApplicationInformationValidationPage,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const dataJson = async () => {
    let jsonData = await loadConfig();

    setJsonData(jsonData);
    return jsonData;
  };
  const [GeneralInformationData, setGeneralInformationData] = useState({
    // ...state.GeneralInformation,
  });
//[,]
//to get all dropdowns
  useEffect(() => {
    setJsonData(dataJson());
    dispatch(GetAllAI_CountryOfResidence());
    dispatch(GetAllAI_NatureOfSupport());
  }, []);
//to get data for GeneralInformation by aI_ApplicationInformationId or params
  useEffect(() => {
    dispatch(
      GetGeneralInformationData(
        localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);
//to add comma for numbers
  const numberWithCommas = (x) => {
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //[,]
  //to assigin data on state after api loding ends

  useEffect(() => {
    if (!state.GeneralInformationLoding) {
      setGeneralInformationData({ ...state.GeneralInformation });

      //console.log("xxxxxzzzzzzzz222",state.GeneralInformationLoding);
    }
  }, [state.GeneralInformationLoding]);

//[,]
//to assigin data on reducer after any change on state GeneralInformationData
  useEffect(() => {
    dispatch(SetGeneralInformation({ ...GeneralInformationData }));
    //console.log("xxxxxzzzzzzzz",count);
  }, [GeneralInformationData]);
  //console.log(state.GeneralInformationLoding,"state.GeneralInformationLoding",state.GeneralInformation);
//[,]
//لافراغ الحقول عند التغيير على areYouCurrentlyFullyDedicatedToTheProject
  useEffect(() => {
    if (
      GeneralInformationData.areYouCurrentlyFullyDedicatedToTheProject ==
        true ||
      GeneralInformationData.areYouCurrentlyFullyDedicatedToTheProject == "true"
    ) {
      setGeneralInformationData((prev) => ({
        ...prev,
        organizationName: null,
        jobTitle: null,
      }));
    }
  }, [GeneralInformationData.areYouCurrentlyFullyDedicatedToTheProject]);
//[,]
//لافراغ الحقول عند التغيير على anyFirstDegreeRelativesInArabBankOrAHSF
  useEffect(() => {
    if (
      GeneralInformationData.anyFirstDegreeRelativesInArabBankOrAHSF == false ||
      GeneralInformationData.anyFirstDegreeRelativesInArabBankOrAHSF == "false"
    ) {
      setGeneralInformationData((prev) => ({
        ...prev,
        fullNameThreeParts: null,
        position: null,
        placeOfWork: null,
      }));
    }
  }, [GeneralInformationData.anyFirstDegreeRelativesInArabBankOrAHSF]);
  //[,]
//لافراغ الحقول عند التغيير على previousFundingSources
  useEffect(() => {
    if (
      GeneralInformationData.previousFundingSources == false ||
      GeneralInformationData.previousFundingSources == "false"
    ) {
      setGeneralInformationData((prev) => ({
        ...prev,
        culturalCivilizationPrograms: null,
        innovationAward: null,
        scientificResearchSupportFund: null,
        supportFromTheArabBank: null,
        numberOfFundingTimes: null,
        whenDidYouReceiveTheLastFunding: null,
        projectName: null,
        aI_NatureOfSupportId: null,
        fundingAmount: null,
        aI_ImplementationLocationPreviousProjectId: null,
      }));
    }
  }, [GeneralInformationData.previousFundingSources]);
  // console.log(state.ApplicationInformation,"jkjkjkjkjkjk");
  
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );

  // useEffect(() => {
  //   const {
  //     areYouCurrentlyFullyDedicatedToTheProject,
  //     anyFirstDegreeRelativesInArabBankOrAHSF,
  //     previousFundingSources,
  //   } = GeneralInformationData;

  //   if (
  //     areYouCurrentlyFullyDedicatedToTheProject === true ||
  //     areYouCurrentlyFullyDedicatedToTheProject === "true"
  //   ) {
  //     setGeneralInformationData((prev) => ({
  //       ...prev,
  //       organizationName: null,
  //       jobTitle: null,
  //     }));
  //   }

  //   if (
  //     anyFirstDegreeRelativesInArabBankOrAHSF === false ||
  //     anyFirstDegreeRelativesInArabBankOrAHSF === "false"
  //   ) {
  //     setGeneralInformationData((prev) => ({
  //       ...prev,
  //       fullNameThreeParts: null,
  //       position: null,
  //       placeOfWork: null,
  //     }));
  //   }

  //   if (
  //     previousFundingSources === false ||
  //     previousFundingSources === "false"
  //   ) {
  //     setGeneralInformationData((prev) => ({
  //       ...prev,
  //       culturalCivilizationPrograms: null,
  //       innovationAward: null,
  //       scientificResearchSupportFund: null,
  //       supportFromTheArabBank: null,
  //       numberOfFundingTimes: null,
  //       whenDidYouReceiveTheLastFunding: null,
  //       projectName: null,
  //       aI_NatureOfSupportId: null,
  //       fundingAmount: null,
  //       aI_ImplementationLocationPreviousProjectId: null,
  //     }));
  //   }
  // }, [GeneralInformationData]);

  let html = (
    <>
      <>
        <div className="form-grid">
          <AllDropDownsAHSF
            fieldsName="fullyAvailableMoment"
            show={true}
            clear={false}
            disabled={shouldDisableFields}
            dropdownType="normal"
            arrayOoptionList={[
              { text: "نعم", value: true },
              { text: "لا", value: false },
            ]}
            KeyText={"text"}
            KeyValue={"value"}
            // defaultValue={
            //   GeneralInformationData?.areYouCurrentlyFullyDedicatedToTheProject
            // }
            value={
              GeneralInformationData?.areYouCurrentlyFullyDedicatedToTheProject
            }
            onChange={(e) => {
              setGeneralInformationData({
                ...GeneralInformationData,
                areYouCurrentlyFullyDedicatedToTheProject: JSON.parse(
                  e.target.value
                ), // التحديث هنا
              });
            }}
            showValidationMessage={
              state.ApplicationInformationValidationPage
                ? state.ApplicationInformationValidationPage.includes(
                    "fullyAvailableMoment"
                  )
                : false
            }
            validationMessage="يرجى تعبئة هذا الحقل"
          />
          {GeneralInformationData.areYouCurrentlyFullyDedicatedToTheProject ==
            false ||
          GeneralInformationData.areYouCurrentlyFullyDedicatedToTheProject ==
            "false" ? (
            <>
              <InputAHSF
                fieldsName="organizationYouWorkFor"
                show={true}
                disabled={shouldDisableFields}
                defaultValue={state.GeneralInformation?.organizationName}
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    organizationName: e.target.value, // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "organizationYouWorkFor"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
              <InputAHSF
                fieldsName="JobTitle"
                show={true}
                disabled={shouldDisableFields}
                defaultValue={state.GeneralInformation?.jobTitle}
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    jobTitle: e.target.value, // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "JobTitle"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
            </>
          ) : (
            ""
          )}
        </div>
        <div className="form-grid">
          <AllDropDownsAHSF
            fieldsName="firstDegreeRelative"
            show={true}
            disabled={shouldDisableFields}
            dropdownType="normal"
            arrayOoptionList={[
              { text: "نعم", value: true },
              { text: "لا", value: false },
            ]}
            KeyText={"text"}
            KeyValue={"value"}
            value={
              GeneralInformationData?.anyFirstDegreeRelativesInArabBankOrAHSF
            }
            onChange={(e) => {
              setGeneralInformationData({
                ...GeneralInformationData,
                anyFirstDegreeRelativesInArabBankOrAHSF: JSON.parse(
                  e.target.value
                ), // التحديث هنا
              });
            }}
            showValidationMessage={
              state.ApplicationInformationValidationPage
                ? state.ApplicationInformationValidationPage.includes(
                    "firstDegreeRelative"
                  )
                : false
            }
            validationMessage="يرجى تعبئة هذا الحقل"
          />
        </div>
        {GeneralInformationData.anyFirstDegreeRelativesInArabBankOrAHSF ==
          true ||
        GeneralInformationData.anyFirstDegreeRelativesInArabBankOrAHSF ==
          "true" ? (
          <div className="form-grid">
            <InputAHSF
              fieldsName="ThreeSyllableName"
              show={true}
              disabled={shouldDisableFields}
              defaultValue={state.GeneralInformation?.fullNameThreeParts}
              onChange={(e) => {
                setGeneralInformationData({
                  ...GeneralInformationData,
                  fullNameThreeParts: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.ApplicationInformationValidationPage
                  ? state.ApplicationInformationValidationPage.includes(
                      "ThreeSyllableName"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="job"
              show={true}
              disabled={shouldDisableFields}
              defaultValue={state.GeneralInformation?.position}
              onChange={(e) => {
                setGeneralInformationData({
                  ...GeneralInformationData,
                  position: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.ApplicationInformationValidationPage
                  ? state.ApplicationInformationValidationPage.includes("job")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="Workplace"
              show={true}
              disabled={shouldDisableFields}
              defaultValue={state.GeneralInformation?.placeOfWork}
              onChange={(e) => {
                setGeneralInformationData({
                  ...GeneralInformationData,
                  placeOfWork: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.ApplicationInformationValidationPage
                  ? state.ApplicationInformationValidationPage.includes(
                      "Workplace"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>
        ) : (
          ""
        )}
        <div className="form-grid">
          <AllDropDownsAHSF
            fieldsName="organizationBeenPreviouslySupported"
            yesNo={true}
            show={true}
            disabled={shouldDisableFields}
            dropdownType="normal"
            arrayOoptionList={[
              { text: "نعم", value: true },
              { text: "لا", value: false },
            ]}
            value={GeneralInformationData?.previousFundingSources}
            KeyText={"text"}
            KeyValue={"value"}
            onChange={(e) => {
              setGeneralInformationData({
                ...GeneralInformationData,
                previousFundingSources: JSON.parse(e.target.value), // التحديث هنا
              });
            }}
            showValidationMessage={
              state.ApplicationInformationValidationPage
                ? state.ApplicationInformationValidationPage.includes(
                    "organizationBeenPreviouslySupported"
                  )
                : false
            }
            validationMessage="يرجى تعبئة هذا الحقل"
          />
        </div>

        {/* <div className="checkbox-container">
        <InputAHSF
          fieldsName="NumberOfSupportTimes"
          show={true}
          type="checkbox"
          className=""
          value=""
          checked={""}
          onChange={(e) => {}}
        />

        <INPUT
          fieldsName="job"
          type="checkbox"
          className=""
          value=""
          checked={""}
          onChange={(e) => {}}
        />

        <INPUT
          fieldsName="job"
          type="checkbox"
          className=""
          value=""
          checked={""}
          onChange={(e) => {}}
        />
        <span>gggg</span>
        <INPUT
          fieldsName="job"
          type="checkbox"
          className=""
          value=""
          checked={""}
          onChange={(e) => {}}
        />
      </div> */}
        {/* //---------------------------------------------------------------------/// */}

        {GeneralInformationData.previousFundingSources == true ||
        GeneralInformationData.previousFundingSources == "true" ? (
          <>
            {state.ApplicationInformationValidationPage ? (
              state.ApplicationInformationValidationPage.includes(
                "PlaceImplementationPreviousProject1"
              ) ? (
                <p style={{ color: "red", marginRight: "30px" }}>
                  يجب اختيار برنامج دعم واحد على الاقل
                </p>
              ) : (
                <></>
              )
            ) : (
              false
            )}
            <div className="checkbox-container">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  disabled={shouldDisableFields}
                  // value=""
                  checked={GeneralInformationData?.culturalCivilizationPrograms}
                  onChange={(e) => {
                    setGeneralInformationData({
                      ...GeneralInformationData,
                      culturalCivilizationPrograms: e.target.checked, // التحديث هنا
                    });
                  }}
                />
                برامج المنح الثقافية
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  disabled={shouldDisableFields}
                  checked={GeneralInformationData?.innovationAward}
                  onChange={(e) => {
                    setGeneralInformationData({
                      ...GeneralInformationData,
                      innovationAward: e.target.checked, // التحديث هنا
                    });
                  }}
                />
                جائزة الابتكار
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  disabled={shouldDisableFields}
                  checked={
                    GeneralInformationData?.scientificResearchSupportFund
                  }
                  onChange={(e) => {
                    setGeneralInformationData({
                      ...GeneralInformationData,
                      scientificResearchSupportFund: e.target.checked, // التحديث هنا
                    });
                  }}
                />
                صندوق دعم البحث العلمي
              </label>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  disabled={shouldDisableFields}
                  checked={GeneralInformationData?.supportFromTheArabBank}
                  onChange={(e) => {
                    setGeneralInformationData({
                      ...GeneralInformationData,
                      supportFromTheArabBank: e.target.checked, // التحديث هنا
                    });
                  }}
                />
                دعم من البنك العربي
              </label>
            </div>

            {/* //----------------------------------------------------------------------// */}
            <div className="form-grid">
              <InputAHSF
                fieldsName="NumberOfSupportTimes"
                type={"number"}
                show={true}
                disabled={shouldDisableFields}
                defaultValue={state.GeneralInformation?.numberOfFundingTimes}
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    numberOfFundingTimes: e.target.value, // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "NumberOfSupportTimes"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
              <InputAHSF
                fieldsName="LastYearOfSupport"
                type={"number"}
                show={true}
                disabled={shouldDisableFields}
                defaultValue={
                  state.GeneralInformation?.whenDidYouReceiveTheLastFunding
                }
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    whenDidYouReceiveTheLastFunding: e.target.value, // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "LastYearOfSupport"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
              <InputAHSF
                fieldsName="GI_ProjectName"
                show={true}
                disabled={shouldDisableFields}
                defaultValue={state.GeneralInformation?.projectName}
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    projectName: e.target.value, // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "GI_ProjectName"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
              {/* <InputAHSF
          fieldsName="NatureOfSupport"
          show={true}
          disabled={false}
          defaultValue={state.GeneralInformation?.jobTitle}
        /> */}
              <AllDropDownsAHSF
                fieldsName="NatureOfSupport"
                yesNo={true}
                show={true}
                disabled={shouldDisableFields}
                dropdownType="normal"
                arrayOoptionList={state.AI_NatureOfSupport}
                KeyText={"natureOfSupportName"}
                KeyValue={"aI_NatureOfSupportId"}
                defaultValue={GeneralInformationData?.aI_NatureOfSupportId}
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    aI_NatureOfSupportId: parseInt(e.target.value), // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "NatureOfSupport"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
              <InputAHSF
                fieldsName="SupportValue"
                show={true}
                comma={true}
                disabled={shouldDisableFields}
                defaultValue={numberWithCommas(
                  state.GeneralInformation?.fundingAmount
                )}
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    fundingAmount: e.target.value, // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "SupportValue"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />

              <AllDropDownsAHSF
                fieldsName="PlaceImplementationPreviousProject"
                show={true}
                disabled={shouldDisableFields}
                dropdownType="normal"
                arrayOoptionList={state.AI_CountryOfResidence}
                KeyText={"countryOfResidenceAr"}
                KeyValue={"aI_CountryOfResidenceId"}
                defaultValue={
                  GeneralInformationData?.aI_ImplementationLocationPreviousProjectId
                }
                onChange={(e) => {
                  setGeneralInformationData({
                    ...GeneralInformationData,
                    aI_ImplementationLocationPreviousProjectId: parseInt(
                      e.target.value
                    ), // التحديث هنا
                  });
                }}
                showValidationMessage={
                  state.ApplicationInformationValidationPage
                    ? state.ApplicationInformationValidationPage.includes(
                        "PlaceImplementationPreviousProject"
                      )
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
            </div>
          </>
        ) : (
          ""
        )}
      </>
    </>
  );//render html after loding ends
  return !state.GeneralInformationLoding ? <>{html}</> : "";
};
export default GeneralinformationModel;
